export default __webpack_public_path__ + "static/media/Balancing_Tube_1_5ml_LT.e173c100.svg";